import type { FaireProductEntity } from "../../entity_types/product";

export const p_yr9bn6eek9: FaireProductEntity = {
  token: "p_yr9bn6eek9",
  type: "product",
  name: "Just Ice Tea, 16oz",
  brandToken: "b_47s98587ya",
  brandName: "Oasis Snacks",
  imageUrl: "https://cdn.faire.com/fastly/902d57de732499aa7729e6c92cf5618696d1627beccf1e5b1ac2521e5fdd46e6.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1c1e171a06e9f7a1cfecdfcbd95bfa7b92856ca15dac49bd5ab45455a6f710a3.jpeg",
    "https://cdn.faire.com/fastly/0529d4a0cafa98f7620b0899e0658cb4cecb24f63b79871feeba17bfba123be8.jpeg",
    "https://cdn.faire.com/fastly/91c810a4ce307f7b5cef8c45a2ac614bfdbe0f7b954e390f6ab62814e4549e55.jpeg",
    "https://cdn.faire.com/fastly/cd974454f36e09b4464c13c8270b482dad57cebadf2eef67eb337c16e8f5f388.jpeg",
    "https://cdn.faire.com/fastly/ace6881d0968345437e13dec6238dbe39266ba4daff9be04eae8c2b53d8f63e4.jpeg",
    "https://cdn.faire.com/fastly/94fedd8ad9425ee6f21856cecf30dc105a2e7d4ffc37fdb72ac7636cdffbc8c6.jpeg",
    "https://cdn.faire.com/fastly/db8b7abb1d791b381993a8a25ccb60e8e8191ae02702b7d37a655587fe79478e.jpeg",
    "https://cdn.faire.com/fastly/27bf3edea34fe8391eadc27b6d82a2d0e255c787fd865c77c9af7e49b8cef987.webp",
    "https://cdn.faire.com/fastly/50ac1e76d99a9d83668cea8b3fe065d3d74e18c83d4da52ff920f0d73a3bb2d2.jpeg",
    "https://cdn.faire.com/fastly/5110018726470f8085151d4db04add90804e583750e9b5132b2c81f862f6b909.jpeg",
    "https://cdn.faire.com/fastly/c78307c056a12ee1a3db06dff900c00ed7634c8d3026bba10f51b09cb0a2ba2b.jpeg",
    "https://cdn.faire.com/fastly/4dc21ff1bea3d8ffd78b767f1c9f82f003ba91f3a56a1f269d8167450fe23142.jpeg",
    "https://cdn.faire.com/fastly/0fe64215b80576a3d8474ffcbb155ce55a16eea745009259155a1ac7eb4d993a.jpeg",
    "https://cdn.faire.com/fastly/49df90bda0f8d14221f72f85b96dcdba3500013d34d436ef4efa5163bc736b83.png",
    "https://cdn.faire.com/fastly/aeff1058db605cc8bc94c2d8f24f0333687f2b932d8abf6df85c6eeeb5aa61a3.jpeg"
  ],
  priceDollars: 3.46,
  description: "All Just Ice Tea varieties are certified organic. This means we commit to a third-party verification process that ensures our ingredients are grown without the use of synthetic pesticides, herbicides, insecticides, and fertilizers. Did you know that tea leaves are one of the few agricultural products that are never rinsed? If chemicals are sprayed on tea leaves during the growing process, the chemicals get washed into the hot tea during the brewing process.",
  tags: [],
  msrpDollars: 5.54,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:53.944Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
